/** KPI Card — 1:1 port z dashboard.jsx KPICard.
 *  4-stĺpcový grid s gap 14, prvá karta vždy `accent`. */

import { useState, type ReactNode } from "react";

export interface KPICardProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  icon?: ReactNode;
  accent?: boolean;
  onClick?: () => void;
}

export function KPICard({ label, value, sub, icon, accent = false, onClick }: KPICardProps) {
  const [hovered, setHovered] = useState(false);
  const baseBorder = accent ? "var(--gold-20)" : "var(--border)";
  const hoverBorder = "var(--border-strong)";
  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className="card"
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      onMouseEnter={() => onClick && setHovered(true)}
      onMouseLeave={() => onClick && setHovered(false)}
      style={{
        padding: 20,
        position: "relative",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        background: accent
          ? "radial-gradient(80% 100% at 100% 0%, rgba(201,169,107,0.12), transparent 60%), var(--bg-card)"
          : "var(--bg-card)",
        borderColor: accent ? "var(--gold-20)" : hovered ? hoverBorder : baseBorder,
        transition: "border-color .14s",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <span style={{ fontSize: 12, color: "var(--text-2)", letterSpacing: "0.04em" }}>
          {label}
        </span>
        <span style={{ color: "var(--text-2)" }}>{icon}</span>
      </div>
      <div
        className="num-lg"
        style={{
          fontSize: 36,
          fontWeight: 600,
          color: accent ? "var(--gold-hi)" : "var(--text)",
          lineHeight: 1,
          marginBottom: 8,
        }}
      >
        {value}
      </div>
      {sub && <div style={{ fontSize: 12, color: "var(--text-3)" }}>{sub}</div>}
    </div>
  );
}
